import { render, staticRenderFns } from "./ViewAbsenceModuleDisabled.vue?vue&type=template&id=876da276&scoped=true&"
import script from "./ViewAbsenceModuleDisabled.vue?vue&type=script&lang=js&"
export * from "./ViewAbsenceModuleDisabled.vue?vue&type=script&lang=js&"
import style0 from "./ViewAbsenceModuleDisabled.vue?vue&type=style&index=0&id=876da276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876da276",
  null
  
)

export default component.exports